import axios from 'axios'

export default {
  getAllRegions: () => axios.get('/api/v1/regions'),
  getTopLevelRegions: () => axios.get('/api/v1/regions/top-level'),
  getChildRegions: (parentRegionId) => axios.get(`/api/v1/regions/${parentRegionId}/child-regions`),
  getLocalisation: (phrase) => axios.get(`/api/v1/localisation/search?query=${phrase}`),
  getLocalisationAutocomplete: (phrase) => axios.get(`/api/v1/localisation/autocomplete?query=${phrase}`)
}
